/**
 * theme.lpFlavour — one selected flavour per page.
 *
 * The magnesium landing pages let you pick the flavour in more than one place
 * (the hero, the closer) and then show it, or buy it, somewhere else again (the
 * product section's button, which has no picker of its own). Those surfaces
 * cannot read each other's DOM, so the selection lives here and travels as a
 * document-level event, the same way the components talk.
 *
 * A publisher calls set() when its own control changes. A subscriber gets every
 * later change, plus the current selection immediately if one has already been
 * made — a section further down the page that loads after the hero still starts
 * out agreeing with it.
 *
 * `source` is the element that caused the change, so a picker can ignore its own
 * broadcast rather than writing back over the radio the buyer just clicked.
 *
 * Idempotent: linked by each section that takes part, so it may run more than once.
 */
window.theme = window.theme || {};

if (!theme.lpFlavour) {
  theme.lpFlavour = (function () {
    var EVENT = "biosphere:lp-flavour:change";
    var current = null;

    return {
      event: EVENT,

      get: function () {
        return current;
      },

      set: function (flavour, source) {
        if (!flavour || !flavour.variantId) return;
        // Re-selecting what is already selected is not a change.
        if (current && current.variantId === flavour.variantId) return;
        current = flavour;
        document.dispatchEvent(
          new CustomEvent(EVENT, {
            detail: { flavour: flavour, source: source || null },
          }),
        );
      },

      subscribe: function (handler) {
        document.addEventListener(EVENT, function (event) {
          handler(event.detail.flavour, event.detail.source);
        });
        if (current) handler(current, null);
      },
    };
  })();
}
